import React from 'react';
import SevenPackages from './SevenPackages';
import { useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
const SevenData = () => {
    const packages = [
        // First 
        // {
        //     name: 'Economy',
        //     hotels: [
        //         {
        //             imageUrl: 'images/umrah/Ramazan umrah.png',
        //             name: 'Hiba Hijra 6',
        //             description: '2500m Misfalah / Hijra street - shuttle',
        //         },
        //         {
        //             imageUrl: 'images/PckgIcon/MadniIcon.png',
        //             name: 'Meezab International',
        //             description: '1200m Al Ayun - shuttle',
        //         },
        //     ],
        //      inclusions: [
        //     { name: 'Flights'},
        //     { name: 'Hotel' },
        //     { name: 'Visa' },
        //     { name: 'Transport'}
        // ],
        //     price: '187,000',
        // },
        // Second
        // {
        //     name: 'Economy',
        //     hotels: [
        //         {
        //             imageUrl: 'images/umrah/Ramazan umrah.png',
        //             name: 'Al Kiswah Towers',
        //             description: '2500m Misfalah / Hijra street - shuttle',
        //         },
        //         {
        //             imageUrl: 'images/PckgIcon/MadniIcon.png',
        //             name: 'DAR WADYAR MADINAH',
        //             description: '1200m Al Ayun - shuttle',
        //         },
        //     ],
        //      inclusions: [
        //     { name: 'Flights'},
        //     { name: 'Hotel' },
        //     { name: 'Visa' },
        //     { name: 'Transport'}
        // ],
        //     price: '191,500',
        // },
        //Third
        {
            name: 'Economy',
            hotels: [
                {
                    imageUrl: 'images/umrah/Ramazan umrah.png',
                    name: 'MANARA BADAYA',
                    description: '850-900 MTR/ MISFALAH KUBRI ROAD - shuttle',
                },
                {
                    imageUrl: 'images/PckgIcon/MadniIcon.png',
                    name: 'MANAZIL MARJAN',
                    description: 'OMAR BIN ABDUL AZIZ ROAD/ - shuttle',
                },
            ],
             inclusions: [
            { name: 'Flights'},
            { name: 'Hotel' },
            { name: 'Visa' },
            { name: 'Transport'}
        ],
            price: '193,000',
        },
        // Fourth
        {
            name: 'Economy',
            hotels: [
                {
                    imageUrl: 'images/umrah/Ramazan umrah.png',
                    name: 'MANZIL AL FATEH  ',
                    description: '700-800 MTR / AL GHAZA SIDE - shuttle',
                },
                {
                    imageUrl: 'images/PckgIcon/MadniIcon.png',
                    name: 'SAFA TOWER',
                    description: '700-800 MTR / BEAR MASJID BILAL - shuttle',
                },
            ],
             inclusions: [
            { name: 'Flights'},
            { name: 'Hotel' },
            { name: 'Visa' },
            { name: 'Transport'}
        ],
            price: '196,000',
        },
        //Fifth
        // {
        //     name: 'Economy',
        //     hotels: [
        //         {
        //             imageUrl: 'images/umrah/Ramazan umrah.png',
        //             name: 'JOHRA AL MAJD',
        //             description: '2500m Misfalah / Hijra street - shuttle',
        //         },
        //         {
        //             imageUrl: 'images/PckgIcon/MadniIcon.png',
        //             name: 'DREAM MADINAH ',
        //             description: '1200m Al Ayun - shuttle',
        //         },
        //     ],
        //      inclusions: [
        //     { name: 'Flights'},
        //     { name: 'Hotel' },
        //     { name: 'Visa' },
        //     { name: 'Transport'}
        // ],
        //     price: '198,500',
        // },
        //Six
        {
            name: 'Economy',
            hotels: [
                {
                    imageUrl: 'images/umrah/Ramazan umrah.png',
                    name: 'RUSHD AL MAJD ',
                    description: '500-600 MTR / IBRAHIM KHALIL ROAD- shuttle',
                },
                {
                    imageUrl: 'images/PckgIcon/MadniIcon.png',
                    name: 'MAJOOM AL MADINAH ',
                    description: '500 MTR / ALI IBN ABI TALIB ROAD - shuttle',
                },
            ],
             inclusions: [
            { name: 'Flights'},
            { name: 'Hotel' },
            { name: 'Visa' },
            { name: 'Transport'}
        ],
            price: '203,500',
        },
        //Seven
        {
            name: 'Economy',
            hotels: [
                {
                    imageUrl: 'images/umrah/Ramazan umrah.png',
                    name: 'DIWAB AL BAIT',
                    description: '500-600 MTR / IBRAHIM KHALIL ROAD - shuttle',
                },
                {
                    imageUrl: 'images/PckgIcon/MadniIcon.png',
                    name: 'ANWAAR TAQWA',
                    description: '500 MTR / BAB AL SALAM ROAD  - shuttle',
                },
            ],
             inclusions: [
            { name: 'Flights'},
            { name: 'Hotel' },
            { name: 'Visa' },
            { name: 'Transport'}
        ],
            price: '203,500',
        },
        //Eight
        // {
        //     name: 'Economy',
        //     hotels: [
        //         {
        //             imageUrl: 'images/umrah/Ramazan umrah.png',
        //             name: 'MELLA 1 & MELLA 2',
        //             description: '2500m Misfalah / Hijra street - shuttle',
        //         },
        //         {
        //             imageUrl: 'images/PckgIcon/MadniIcon.png',
        //             name: 'KANOOZ AL TAQWA ',
        //             description: '1200m Al Ayun - shuttle',
        //         },
        //     ],
        //      inclusions: [
        //     { name: 'Flights'},
        //     { name: 'Hotel' },
        //     { name: 'Visa' },
        //     { name: 'Transport'}
        // ],
        //     price: '205,500',
        // },
        //Nine
        // {
        //     name: 'Economy',
        //     hotels: [
        //         {
        //             imageUrl: 'images/umrah/Ramazan umrah.png',
        //             name: 'SAIF AL MAJD ',
        //             description: '2500m Misfalah / Hijra street - shuttle',
        //         },
        //         {
        //             imageUrl: 'images/PckgIcon/MadniIcon.png',
        //             name: 'WARDA SAFA',
        //             description: '1200m Al Ayun - shuttle',
        //         },
        //     ],
        //      inclusions: [
        //     { name: 'Flights'},
        //     { name: 'Hotel' },
        //     { name: 'Visa' },
        //     { name: 'Transport'}
        // ],
        //     price: '213,500',
        // },
        //Ten
        // {
        //     name: 'Economy',
        //     hotels: [
        //         {
        //             imageUrl: 'images/umrah/Ramazan umrah.png',
        //             name: 'MATHER AL JEWAR',
        //             description: '2500m Misfalah / Hijra street - shuttle',
        //         },
        //         {
        //             imageUrl: 'images/PckgIcon/MadniIcon.png',
        //             name: 'BIR AL EIMAN',
        //             description: '1200m Al Ayun - shuttle',
        //         },
        //     ],
        //      inclusions: [
        //     { name: 'Flights'},
        //     { name: 'Hotel' },
        //     { name: 'Visa' },
        //     { name: 'Transport'}
        // ],
        //     price: '214,000',
        // },
        //Eleven
        // {
        //     name: 'Economy',
        //     hotels: [
        //         {
        //             imageUrl: 'images/umrah/Ramazan umrah.png',
        //             name: 'BADAR AL MASSA ',
        //             description: '2500m Misfalah / Hijra street - shuttle',
        //         },
        //         {
        //             imageUrl: 'images/PckgIcon/MadniIcon.png',
        //             name: 'TEIF NIBRAS ',
        //             description: '',
        //         },
        //     ],
        //      inclusions: [
        //     { name: 'Flights'},
        //     { name: 'Hotel' },
        //     { name: 'Visa' },
        //     { name: 'Transport'}
        // ],
        //     price: '222,000',
        // },
        //Twelve
        // {
        //     name: 'Economy',
        //     hotels: [
        //         {
        //             imageUrl: 'images/umrah/Ramazan umrah.png',
        //             name: 'MAWARA SHAMS 2',
        //             description: '2500m Misfalah / Hijra street - shuttle',
        //         },
        //         {
        //             imageUrl: 'images/PckgIcon/MadniIcon.png',
        //             name: 'KANOOZ AL TAQWA ',
        //             description: '1200m Al Ayun - shuttle',
        //         },
        //     ],
        //      inclusions: [
        //     { name: 'Flights'},
        //     { name: 'Hotel' },
        //     { name: 'Visa' },
        //     { name: 'Transport'}
        // ],
        //     price: '205,500',
        // },
    ];

    const getVisiblePackages = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth >= 1200) {
            return 4;
        } else if (screenWidth >= 768) {
            return 2;
        } else {
            return 1;
        }
    };

    const [visiblePackages, setVisiblePackages] = useState(getVisiblePackages());

    useEffect(() => {
        const handleResize = () => {
            setVisiblePackages(getVisiblePackages());
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const packageChunks = [];
    for (let i = 0; i < packages.length; i += visiblePackages) {
        packageChunks.push(packages.slice(i, i + visiblePackages));
    }
    const handleDownloadCSI = () => {
        const pdfUrl = '../../images/umrahpackages.pdf';
        const anchor = document.createElement('a');
        anchor.href = pdfUrl;
        anchor.download = 'UmrahPackages-2024.pdf';
        anchor.click();
    };
    return (
        <section className='unique-packages-section'>
        
                <div className='container'>
                  
                <div className='row'>
                    <Carousel indicators={true} controls={false} interval={null}>
                        {packageChunks.map((chunk, index) => (
                            <Carousel.Item key={index}>
                                <div className="d-flex">
                                    {chunk.map((pkg, pkgIndex) => (
                                        <SevenPackages key={pkgIndex} packageData={pkg} />
                                    ))}
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
              

                </div>
                  
                <div className="unique-center">
                    <p>
                        <a target="_blank" rel="noopener noreferrer">
                            <button onClick={handleDownloadCSI}>
                                <b>7 Days Economy Umrah Packages PDF Download</b>
                            </button>
                        </a>
                    </p>
                </div>
            
        </section>
    );
};

export default SevenData;